import { requests } from './baseServices'

export const ExpenseWithCostsServices = {    
    getAll: (criteria) => requests.get('api/expensewithcosts', criteria),
    getAllWithOptions: (criteria) => requests.post('api/expensewithcosts/filtered', criteria),
    getById: (id) => requests.get(`api/expensewithcosts/${id}`),
    update: (id, template) => requests.put(`api/expensewithcosts/${id}`, template),
    create: (template) => requests.post(`api/expensewithcosts`, template),    
    delete: (id) => requests.delete(`api/expensewithcosts/${id}`),        
    duplicate: (id) => requests.post(`api/expensewithcosts/duplicate/${id}`),
};